import { FETCH_ALL, CREATE, UPDATE, DELETE } from '../constants/actionTypes';

export default (lecturerProject = [], action) => {
    switch (action.type) {
        case FETCH_ALL:
            return action.payload;
        case CREATE:
            return [...lecturerProject, action.payload];
        case UPDATE:
            return lecturerProject.map((project) => project._id === action.payload._id ? action.payload : project);
        case DELETE:
            return lecturerProject.filter((project) => project._id !== action.payload);
        default:
            return lecturerProject;
    }
}